import Addresses from './Addresses';
import CmDeliveryNoteNumber from './CmDeliveryNoteNumber';
import Created from './Created';
import CreatorUser from './CreatorUser';
import Customers from './Customers';
import DeliveryDate from './DeliveryDate';
import Id from './Id';
import Orders from './Orders';
import ReceiptNumber from './ReceiptNumber';
import Sales from './Sales';
import Status from './Status';
import Storage from './Storage';
import StorageUser from './StorageUser';
import Updated from './Updated';
import Weight from './Weight';

export const compareTypes = {};

export const labels = {
  Id: 'Id',
  ReceiptNumber: 'Bizonylatszám',
  CmDeliveryNoteNumber: 'CM szlev száma',
  Status: 'Státusz',
  Storage: 'Raktár',
  StorageUser: 'Raktáros',
  Weight: 'Össztömeg',
  Orders: 'Rendelések',
  Sales: 'Szállítólevelek',
  DeliveryDate: 'Szállítás dátuma',
  Customers: 'Átvevevők',
  Addresses: 'Címek',
  CreatorUser: 'Rögzítette',
  Created: 'Rögzítve',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'Storage',
}, {
  value: 'StorageUser',
}, {
  value: 'CreatorUser',
}, {
  value: 'DeliveryDate',
}, {
  value: 'Weight',
}, {
  value: 'Customers',
}, {
  value: 'Addresses',
}, {
  value: 'Orders',
}, {
  value: 'Sales',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Status',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'Status',
}, {
  value: 'Storage',
}, {
  value: 'StorageUser',
}, {
  value: 'Weight',
}, {
  value: 'DeliveryDate',
}, {
  value: 'Orders',
}, {
  value: 'Sales',
}, {
  value: 'Customers',
}, {
  value: 'Addresses',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  ReceiptNumber,
  CmDeliveryNoteNumber,
  Status,
  Storage,
  StorageUser,
  Weight,
  Orders,
  Sales,
  DeliveryDate,
  Customers,
  Addresses,
  CreatorUser,
  Created,
  Updated,
};
